import { render, staticRenderFns } from "./TrueFalseMultiSelect.vue?vue&type=template&id=506e09f7&"
import script from "./TrueFalseMultiSelect.vue?vue&type=script&lang=ts&"
export * from "./TrueFalseMultiSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports